import React, { useState } from 'react';
import { useForm } from 'react-hook-form'

import {
  Button,
  Input,
  Form,
  FormFeedback,
  FormGroup,
  Label
  } from "reactstrap";

// Kept in one place so the submitted consent record matches what the user saw
const CONSENT_TEXT = "I agree to receive text messages from Unlimited Transportation about dispatch and delivery assignments, including pickup ETAs, delivery confirmations, and in and out times, at the phone number provided. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to opt out at any time. Consent is not a condition of employment.";

function SmsOptInForm(props) {
  const { register, handleSubmit, errors, reset } = useForm();
  const [validated, setValidation] = useState(false);
  const onSubmit = async (data) => {
    // Shares the contact form's Zap so sign-ups land with contact messages
    const url = 'https://hooks.zapier.com/hooks/catch/8871696/olux56o/';
    const method = 'POST';
    const consent = data.smsConsent ? "Yes" : "No";
    const body = JSON.stringify({
      fullName: data.fullName,
      phone: data.phone,
      smsConsent: consent,
      source: "Text Updates page",
      message: `Text Updates sign-up. SMS consent: ${consent}. Consent language shown: "${CONSENT_TEXT}" Submitted: ${new Date().toISOString()}`,
    });

    let res;
    try {
      res = await fetch(url, { method, body });
    } catch(err) {
      console.log('Error sending request to Zapier: ', err);
      setValidation(false)
      return;
    }

    if (res.status !== 200) {
      console.log('Error sending request to Zapier: ', res);
      setValidation(false);
      return;
    }

    reset()
    return setValidation(true);
  }

    return(
        <Form className="justify-content-center text-left" id="sms-opt-in-form">
          {/* Name Input */}
          <Label>Full Name*</Label>
          <FormGroup>
            <Input
              className={errors.fullName && "is-invalid"}
              innerRef={register({ required: true})}
              placeholder="Full Name"
              type="text"
              name="fullName"
            ></Input>
            {errors.fullName && <FormFeedback>This is required.</FormFeedback>}
          </FormGroup>

          {/* Phone Input */}
          <Label>Mobile Phone Number*</Label>
          <FormGroup>
            <Input
              className={errors.phone && "is-invalid"}
              innerRef={register({ required: true})}
              placeholder="Mobile Phone Number"
              type="tel"
              name="phone"
            ></Input>
            {errors.phone && <FormFeedback>This is required.</FormFeedback>}
          </FormGroup>

          {/* SMS Consent - must stay optional and unchecked by default for carrier review */}
          <FormGroup check className="sms-consent">
            <Label check>
              <Input
                innerRef={register}
                name="smsConsent"
                type="checkbox"
              ></Input>
              <span className="form-check-sign"></span>
              {CONSENT_TEXT} See our <a href="/sms-terms" target="_blank" rel="noopener noreferrer">SMS Terms</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </Label>
          </FormGroup>

          {/* Submit Button */}
          <div className="text-center mt-4">
            <Button
              className="btn-square"
              color="info"
              type="submit"
              onClick={handleSubmit(onSubmit)}
              size="md"
            >
              Submit
            </Button>
          </div>
          {validated && <p className="text-center pt-4 category">Thanks! Your information has been submitted.</p>}
        </Form>
  );
}

export default SmsOptInForm;
